import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAppState } from '../../../../../../common/context/context'
import { Vehicle } from '../../../../../../common/types/Vehiculo'
import { selectSearchNeumaticos } from '../../../searchNeumaticos.store'

interface SearchNeumaticosVehiculoState {
  loading: boolean
  matricula: string | null
  vehiculos: Vehicle[] | null
  selectedVehicle?: Vehicle
  error: string | null
}

export const initialState: SearchNeumaticosVehiculoState = {
  loading: false,
  matricula: null,
  vehiculos: null,
  selectedVehicle: undefined,
  error: null,
}

export type SearchNeumaticosVehiculoStateType = typeof initialState
export const key = 'searchNeumaticos/Vehiculo'

const vehiculoSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    buscarVehiculos: (state, action: PayloadAction<string>) => {
      const isSameMatricula =
        state.matricula != null &&
        state.matricula.toUpperCase() === action.payload.toUpperCase()

      state.matricula = action.payload
      state.loading = true
      state.error = null

      if (!isSameMatricula) {
        state.vehiculos = null
        state.selectedVehicle = undefined
      }
    },
    buscarVehiculosExito: (state, action: PayloadAction<Vehicle[]>) => {
      state.loading = false
      state.vehiculos = action.payload
      state.error = null
    },
    buscarVehiculosError: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
    setSelectedVehicle: (state, action: PayloadAction<Vehicle>) => {
      state.selectedVehicle = action.payload
    },
    clearSelectedVehicle: (state) => {
      state.selectedVehicle = undefined
    },
    resetVehiculoSearch: () => initialState,
  },
})

export const {
  buscarVehiculos,
  buscarVehiculosExito,
  buscarVehiculosError,
  setSelectedVehicle,
  clearSelectedVehicle,
  resetVehiculoSearch,
} = vehiculoSlice.actions

export default vehiculoSlice.reducer

export const selectVehiculoState = (
  state: IAppState
): SearchNeumaticosVehiculoState => selectSearchNeumaticos(state).vehiculo

export const selectLoading = (state: IAppState) =>
  selectVehiculoState(state).loading

export const selectMatricula = (state: IAppState) =>
  selectVehiculoState(state).matricula

export const selectVehiculos = (state: IAppState) =>
  selectVehiculoState(state).vehiculos

export const selectError = (state: IAppState) =>
  selectVehiculoState(state).error

export const selectIsVehicleFound = (state: IAppState) =>
  (selectVehiculoState(state).vehiculos?.length ?? 0) > 0

export const selectSelectedVehicle = (state: IAppState) =>
  selectVehiculoState(state).selectedVehicle
